import React from 'react';
import { HyperText } from '../components/HyperText';
import { DifferentiatorsTimeline } from '../components/DifferentiatorsTimeline';
import { StrategicFeatures } from '../components/StrategicFeatures';
const StrategyPage = () => {
  return <div className="w-full min-h-screen bg-center bg-cover bg-no-repeat bg-gray-900" style={{
    backgroundImage: `url(https://uploadthingy.s3.us-west-1.amazonaws.com/ib3Dyczi1YEyT6WYET97wp/bgbluee2.png)`
  }} data-id="element-374">
      <div className="pt-28 sm:pt-32 md:pt-36" data-id="element-375">
        <div className="max-w-7xl mx-auto px-4 sm:px-6" data-id="element-376">
          {/* Strategy Section - Now First */}
          <div className="mb-16 sm:mb-24" data-id="element-377">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-light text-white text-center tracking-normal mb-8 sm:mb-12" data-id="element-378">
              Our Strategy
            </h2>
            <div className="bg-gray-900/50 p-4 sm:p-6 md:p-8 rounded-2xl border border-gray-700 shadow-sm" data-id="element-379">
              <StrategicFeatures data-id="element-380" />
            </div>
          </div>
          {/* Differentiators Section - Now Second */}
          <div className="mb-16 sm:mb-24" data-id="element-381">
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-light text-white mb-8 sm:mb-12 tracking-normal text-center" data-id="element-382">
              Our Differentiators
            </h1>
            <div className="bg-gray-900/50 p-4 sm:p-6 md:p-8 rounded-2xl border border-gray-700 shadow-sm" data-id="element-383">
              <div className="min-h-[600px] sm:min-h-[700px]" data-id="element-384">
                <DifferentiatorsTimeline data-id="element-385" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default StrategyPage;